<template>
    <div class="container">
      <RegisterForm />
    </div>
  </template>
  
  <script>
  import RegisterForm from '@/components/RegisterForm.vue';
  
  export default {
    components: {
      RegisterForm,
    },
  };
  </script>
  
  <style scoped>
  .container {
    margin-top: -20px;
    /* max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center; */
  }
  </style>